// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.dynamic.WorkflowTestTriggersResultResponse */
/* istanbul ignore next */
@GandalfModel
export class WorkflowTestTriggersResultResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	diagnosesTriggered!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	servicesTriggered!: boolean | null;

	@GandalfArray(Number)
	triggeredScreenIds!: number[] | null;

}
